import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=67e01451&scoped=true"
import script from "./Memo.vue?vue&type=script&lang=ts"
export * from "./Memo.vue?vue&type=script&lang=ts"
import style0 from "./Memo.vue?vue&type=style&index=0&id=67e01451&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e01451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e01451')) {
      api.createRecord('67e01451', component.options)
    } else {
      api.reload('67e01451', component.options)
    }
    module.hot.accept("./Memo.vue?vue&type=template&id=67e01451&scoped=true", function () {
      api.rerender('67e01451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/Memo.vue"
export default component.exports